module.exports = __webpack_public_path__ + "static/media/reservation_title_image.a2570be8.png";